import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpService } from "../service/http-service";
import { Location } from "@angular/common";
import { FileUpload } from "../service/file-upload";
import { CommonService } from "../service/common";
import { API } from "../config/api-config";

declare var $: any;
@Component({
  selector: "app-goal-edit",
  templateUrl: "./goal-edit.component.html",
  styleUrls: ["./goal-edit.component.css"],
})
export class GoalEditComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private HttpService: HttpService,
    private location: Location,
    private fileupload: FileUpload,
    private common: CommonService
  ) {}

  private id: number = 0;

  public isCreate: boolean = false;

  public imagePath: string = "";

  public data: any = {
    active: 1,
    estimatedDay: 0,
    imageEn: "",
    imageTc: "",
    income: 0,
    nameEn: "",
    nameTc: "",
    id: 0,
  };

  public goalTaskData = [];

  public selectedTask: any = null;

  ngOnInit() {
    this.getPath();
    this.getGoalTask();
    this.route.params.subscribe((params) => {
      this.id = params["id"];
      this.data.id = this.id;
    });
    if (this.id != 0) {
      this.getData();
      this.getGoalRelation();
    } else {
      this.isCreate = true;
    }
  }

  public showImageEn: boolean = false;
  public showImageTc: boolean = false;
  public showDetailImageTc: boolean = false;
  public showDetailImageEn: boolean = false;
  private tempPath: string = API.getTemp;
  public upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case "imageEn":
            self.showImageEn = true;
            break;
          case "imageTc":
            self.showImageTc = true;
            break;
          case "detailImageEn":
            self.showDetailImageEn = true;
            break;
          case "detailImageTc":
            self.showDetailImageTc = true;
            break;
        }
        self.data[name] = temRes.data.fileName;
      }
    });
  }

  private getPath(): void {
    this.HttpService.getData(API.resourcePath).then((res) => {
      this.imagePath = res.data;
    });
  }

  public submit(): void {
    console.log(this.selectedTask);
    let data = this.data;
    delete data.goalTaskIds;
    console.log(data);
    delete data.updatedTime;
    delete data.updatedBy;
    delete data.createdTime;
    delete data.createdBy;
    this.HttpService.postData(API.goalUpdate, data).then((res) => {
      let data = res;
      if (data.status.code == 0 || data.status.code == "0") {
        this.updateRelation(data.data).then((_) => {
          this.location.back();
        });
      } else {
        alert(data.status.message);
      }
    });
  }

  private updateRelation(id) {
    let data = { goalId: id, goalTaskIds: this.selectedTask };
    return this.HttpService.postData(API.goalRealtionUpdate, data).then(
      (res) => {
        Promise.resolve(res);
      }
    );
  }

  private getData(): void {
    this.HttpService.getData(API.goalList + "/" + this.id).then((res) => {
      this.data = res.data;
    });
  }

  private getGoalTask() {
    this.HttpService.getData(API.goalTask).then((res) => {
      this.goalTaskData = res.data;
    });
  }

  private getGoalRelation() {
    this.HttpService.getData(API.goalRealtion + this.id).then((res) => {
      let a = [];
      res.data.forEach((item) => {
        a.push(item.id);
      });
      this.selectedTask = a;
    });
  }
}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/goal-edit/goal-edit.component.ts